import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { OverviewCardHeaderComponent } from './overview-card-header.component';
import { LayoutContainerComponent } from './layout-container.component';
import { MenuItem } from './menu-item.types';
import { NgIf } from '@angular/common';

@Component({
  selector: 'hk-overview-card',
  template: `
    <hk-overview-card-header
      *ngIf="titleText"
      (caretButtonClicked)="caretButtonClicked.emit()"
      [caretButtonDisabled]="caretButtonDisabled"
      [caretButtonText]="caretButtonText"
      [titleText]="titleText"
      [isScrolled]="isScrolled"
      [cardMenuItems]="cardMenuItems"
      [titleBadge]="titleBadge"
      [searchEnabled]="searchEnabled"
      [tabMenuButtons]="tabMenuButtons"
      (searchValueChange)="searchValueChange.emit($event)"
      class="flex"
    >
      <ng-content header-title-content select="[header-title-content]"></ng-content>
      <ng-content select="[header-content]"></ng-content>
    </hk-overview-card-header>
    <hk-layout-container (scrollEvent)="isScrolled = $event" [scrollable]="scrollable">
      <ng-content></ng-content>
    </hk-layout-container>
    <ng-content select="[hkCardContentExpandable]"></ng-content>
  `,
  host: { class: 'flex flex-col flex-1 bg-white px-6  pb-6 rounded-sm gap-2 min-h-[500px] xl:min-h-[300px]' },
  imports: [OverviewCardHeaderComponent, LayoutContainerComponent, NgIf],
  standalone: true,
})
export class OverviewCardComponent implements AfterViewInit {
  @Input() public titleText = '';
  @Input() public caretButtonText = '';
  @Input() public caretButtonDisabled = false;
  @Input() cardMenuItems = [] as MenuItem[];
  @Output() caretButtonClicked = new EventEmitter<void>();
  @Input() public titleBadge: number | undefined;
  @Input() public searchEnabled = false;
  @Input() public tabMenuButtons = [] as MenuItem[];
  @Output() searchValueChange = new EventEmitter<string>();
  @Input() public scrollable = true;
  isScrolled = false;

  constructor(private _elementReference: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    const expandableContent = this._elementReference.nativeElement.querySelectorAll('[hkcardcontentexpandable]');
    if (expandableContent.length > 0) {
      this._elementReference.nativeElement.classList.remove('min-h-[500px]', 'xl:min-h-[300px]');
    }
  }
}
